import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRotateImage = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M11.75 22.75H7.25C3.1 22.75 1.25 20.9 1.25 16.75V12.25C1.25 8.1 3.1 6.25 7.25 6.25H11.75C15.9 6.25 17.75 8.1 17.75 12.25V16.75C17.75 20.9 15.9 22.75 11.75 22.75ZM7.25 7.75C3.93 7.75 2.75 8.93 2.75 12.25V16.75C2.75 20.07 3.93 21.25 7.25 21.25H11.75C15.07 21.25 16.25 20.07 16.25 16.75V12.25C16.25 8.93 15.07 7.75 11.75 7.75H7.25Z",
		fill: "white"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M22.9985 8.5C22.5885 8.5 22.2485 8.16 22.2485 7.75C22.2485 4.79 20.1885 2.31 17.4185 1.66L17.6885 2.11C17.8985 2.47 17.7885 2.93 17.4285 3.14C17.0685 3.35 16.6085 3.24 16.3985 2.88L15.3485 1.13C15.2085 0.9 15.2085 0.61 15.3385 0.38C15.4785 0.15 15.7285 0 15.9985 0C20.2685 0 23.7485 3.48 23.7485 7.75C23.7485 8.16 23.4085 8.5 22.9985 8.5Z",
		fill: "white"
	})]
});
export default SvgRotateImage;
